import { Button, Form, Input, Modal, Spin, Table, Tag } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import { getUpdateStateDevicesReturn, openMessage, socketEmitEvent } from '../../redux/actions';
import { DownloadOutlined, DragOutlined, SaveOutlined, SearchOutlined, SendOutlined } from '@ant-design/icons';
import TinymceEditor from '../../components/TinymceEditor';
import InputTag from '../../components/InputTag';
import * as XLSX from 'xlsx';
import { NOTIFIES, STATE_MAINTAIN, STATE_OFF, STATE_ON } from '../../constants/system.keys';
import { getListDeviceByStateWS } from '../../socket/statistics';
import moment from 'moment';
import { getDeviceNotesApi } from '../../api/customerApi';


const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const extractIPFromRTSP = (rtspUrl) => {
  if (!rtspUrl) return null;
  try {
    const parts = rtspUrl.split('//');
    if (parts.length > 1) {
      const afterProtocol = parts[1];
      const ipPart = afterProtocol.split(':')[0];
      return ipPart;
    }
    return null;
  } catch (error) {
    console.error('Error extracting IP from RTSP URL:', error);
    return null;
  }
};

const ModalListDevice = ({ mode, deviceState, open, onClose }) => {
  const [formSendEmail] = Form.useForm();
  const emailContentRef = useRef();
  const [requestId] = useState(new Date().getTime());
  const [page, setPage] = useState(0);
  const [size] = useState(10);
  const [name, setName] = useState('');
  const [tag, setTag] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [visiblSendMail, setVisiblSendMail] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [dataDeviceSelect, setDataDeviceSelect] = useState();
  const [visiblMaintain, setVisiblMaintain] = useState(false);
  const [dataEditorTable, setDataEditorTable] = useState();
  const [isLoadingSendEmail, setIsLoadingSendEmail] = useState(false);
  const [keyTable, setKeyTable] = useState(Math.random());
  const [isExporting, setIsExporting] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    listCameraByState,
    listGatewayByState,
    namespace,
    updateStateDevices,
    cameras: cameraPage,
    gateways: gatewayPage,
  } = useSelector(
    (state) => state
  );

  useEffect(() => {
    setIsLoading(false);
  }, [listCameraByState, listGatewayByState]);

  useEffect(() => {
    setDataDeviceSelect(null);
  }, []);

  useEffect(() => {
    if (updateStateDevices?.serials) {
      setVisiblMaintain(false)
      onClose()
      dispatch(getUpdateStateDevicesReturn());
    }
  }, [updateStateDevices]);

  const getListDeviceByPage = useCallback((noCache = 1) => {
    setIsLoading(true);
    let data = {
      namespace,
      deviceType: mode === 0 ? 'camera' : 'gateway',
      timeRequest: new Date().getTime(),
      state: deviceState,
      page,
      size,
      ...(noCache ? { noCache: 1 } : {}),
      ...(name && { name }),
      ...(tag && { tag }),
    };
    console.log("🚀 ~ ModalListDevice ~ data:", data)
    let dataObj = {
      appServiceType: SERVICE.LIST_DEVICE_BY_STATE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  }, [
    deviceState,
    dispatch,
    mode,
    name,
    namespace,
    page,
    size,
    tag,
  ]);

  const onCancelSendMail = () => {
    formSendEmail.resetFields()
    setVisiblSendMail(false)
  }

  const onHandleSendEmail = () => {
    setVisiblSendMail(true)
    setIsLoadingSendEmail(true)
    setTimeout(() => {
      setIsLoadingSendEmail(false)
    }, 1000);
  }

  const cameraColumns = [
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('Serial'),
      dataIndex: 'serial',
      key: 'serial',
    },
    {
      title: t('Gateway name'),
      dataIndex: 'gatewayName',
      key: 'gatewayName',
    },
    {
      title: t('Address'),
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: t('Tags'),
      dataIndex: 'tags',
      key: 'tags',
      render: (tags) =>
        tags &&
        tags.split(';').map(
          (tag) =>
            !!tag && (
              <Tag key={tag} style={{ margin: 3 }}>
                {tag}
              </Tag>
            )
        ),
    },
  ];

  const gatewayColumns = [
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('Serial'),
      dataIndex: 'serial',
      key: 'serial',
    },
    {
      title: t('Address'),
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: t('Tags'),
      dataIndex: 'tags',
      key: 'tags',
      render: (tags) =>
        tags &&
        tags.split(';').map(
          (tag) =>
            !!tag && (
              <Tag key={tag} style={{ margin: 3 }}>
                {tag}
              </Tag>
            )
        ),
    },
  ];

  useEffect(() => {
    getListDeviceByPage();
  }, [getListDeviceByPage]);

  const handleSearch = (values) => {
    setName(values.name);
    setTag(values.tag);
    setPage(0);
  };

  const handleOnClose = (e, deviceItem) => {
    e.preventDefault();
    setDataDeviceSelect(dataDeviceSelect?.filter(item => item?.serial !== deviceItem?.serial))
  }

  const onCancelMaintain = () => {
    setVisiblMaintain(false)
  }

  const onHandleMaintain = () => {
    setVisiblMaintain(true)
  }

  const onSubmitMaintain = (datas) => {
    let data = {
      namespace,
      serials: datas?.map(item => item?.serial)?.join(';'),
      state: 2
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_STATE_DEVICES,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    }
    dispatch(socketEmitEvent(dataObj));
  }

  const handleOnSend = (value) => {
    let data = {
      namespace,
      emails: value?.emails?.join(';') ?? '',
      emailTitle: value?.emailTitle ?? '',
      emailContent: emailContentRef?.current?.getContent() ?? '',
    };
    let dataObj = {
      appServiceType: SERVICE.SEND_EMAIL_NOTIFICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    }
    dispatch(socketEmitEvent(dataObj));
    setVisiblSendMail(false)
    setDataDeviceSelect(null)
    setDataEditorTable(null)
    setKeyTable(Math.random())
    formSendEmail.resetFields()
  }

  const getDeviceNotes = useCallback(async (serial = null) => {
    const filter = {
      serial,
      limit: 10,
      offset: 0,
      fromDate: moment('01-01-2019', 'MM-DD-YYYY'),
      toDate: moment()
    };
    if (filter?.serial) {
      const token = localStorage.getItem('token_cms');
      const namespace = localStorage.getItem('namespace');
      return getDeviceNotesApi(
        token,
        {
          namespace
        },
        convertFilterToParams(filter)
      );
    }
  }, []);

  const getGatewayStateText = (stateVal) => {
    if (stateVal === 1) return 'Online';
    if (stateVal === 0) return 'Offline';
    return 'Unknown';
  };

  const fetchNotes = async (device) => {
    const noteRes = await getDeviceNotes(device.serial);
    const notes = (noteRes?.data?.records ?? [])
      .map((r) => {
        const dateStr = r.updatedAt ? moment(r.updatedAt).format('DD/MM/YYYY HH:mm:ss') : '';
        const authorStr = r.fullname || r.username || '';
        return `${r.message ?? ''} - ${dateStr} by ${authorStr}`.trim();
      })
      .join(';');
    return { ...device, notes };
  };

  const getStateText = (stateVal) => {
    if (stateVal === STATE_ON) return 'Online';
    if (stateVal === STATE_MAINTAIN) return 'Maintain';
    if (stateVal === STATE_OFF) return 'Offline';
    return 'Unknown';
  };

  const onExport = async () => {
    const dataTimeRequest = new Date().getTime();
    const stat = mode === 0 ? cameraPage : gatewayPage;
    const totalSize = (Number(stat?.numberOffline) || 0);
    const data = {
      namespace,
      deviceType: mode === 0 ? 'camera' : 'gateway',
      timeRequest: dataTimeRequest,
      state: deviceState,
      page: 0,
      size: totalSize || 1000,
      noCache: 1,
    };
    try {
      setIsExporting(true);
      const res = await getListDeviceByStateWS(data);

      if (!res || !res.devices || res.devices.length === 0) {
        openMessage(NOTIFIES.WARNING, 'No data to export');
        return;
      }

      // const devicesWithNotes = await Promise.all(res.devices.map(fetchNotes));

      let mappedData = [];
      if (mode === 0) {
        mappedData = res.devices.map((device) => {
          let resolvedIp = device.ipAddress ? device.ipAddress.replace('/', '') : '';
          if (!resolvedIp && device.source) {
            resolvedIp = extractIPFromRTSP(device.source) || '';
          }

          return {
            'Name': device.name ?? '',
            'Serial': device.serial ?? '',
            'State': getStateText(device.state),
            'Address': device.note ?? '',
            'Gateway Name': device.gatewayName ?? '',
            "Tags": device.tags ?? '',
            "Updated at": device?.updatedAt ?? ''
          };
        });
      } else {
        mappedData = res.devices.map((device) => ({
          'Name': device.name ?? '',
          'Serial': device.serial ?? '',
          'State': getGatewayStateText(device.state),
          'Address': device.note ?? '',
          "Tags": device.tags ?? '',
          "Updated at": device?.updatedAt ?? ''
        }));
      }

      const worksheet = XLSX.utils.json_to_sheet(mappedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Devices');

      const filename = `${mode === 0
        ? `report-log-camera-${deviceState === STATE_ON ? 'online' : deviceState === STATE_OFF ? 'offline' : 'maintain'}_${namespace}`
        : `report-log-gateway-${deviceState === STATE_ON ? 'online' : deviceState === STATE_OFF ? 'offline' : 'maintain'}_${namespace}`
        }.${moment().format('DD_MM_YYYY')}.xlsx`;

      XLSX.writeFile(workbook, filename);
      openMessage(NOTIFIES.SUCCESS, 'Export success');
    } catch (err) {
      console.error('🚀 ~ onExport ~ error:', err);
      openMessage(NOTIFIES.ERROR, 'Export failed');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Modal
      title={`List ${mode === 0 ? 'camera' : 'gateway'} ${deviceState === 0 ? 'offline' : deviceState === 1 ? 'online' : 'maintain'
        }`}
      visible={open}
      onCancel={onClose}
      width="75vw"
      footer={null}
      style={{ top: 50 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Form
          initialValues={{ name: '', tag: '' }}
          onFinish={handleSearch}
          layout="inline"
          style={{ marginBottom: 20 }}
        >
          <Form.Item label={t('Name')} name="name">
            <Input
              allowClear
              onChange={(e) => {
                if (!e.target.value) {
                  setName('');
                  setPage(0);
                }
              }}
            />
          </Form.Item>
          <Form.Item label={t('Tag')} name="tag">
            <Input
              allowClear
              onChange={(e) => {
                if (!e.target.value) {
                  setTag('');
                  setPage(0);
                }
              }}
            />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" icon={<SearchOutlined />}>
              {t('Search')}
            </Button>
          </Form.Item>
        </Form>
        {
          (deviceState === STATE_OFF || deviceState === STATE_MAINTAIN) && (
            <Button
              icon={<DownloadOutlined />}
              type='primary'
              onClick={onExport}
              loading={isExporting}
            >
              {t('Export')}
            </Button>
          )
        }
        {dataDeviceSelect?.length > 0 && (
          <div>
            <Button
              onClick={() => onHandleMaintain()}
              style={{ marginRight: '16px' }}
              icon={<DragOutlined />}
            >
              {t('Move to maintain')}
            </Button>
            <Button
              onClick={() => onHandleSendEmail(dataDeviceSelect)}
              icon={<SendOutlined />}
            >
              {t('Send Email')}
            </Button>
          </div>
        )}
      </div>
      <Table
        style={{ overflow: 'auto' }}
        loading={isLoading}
        key={keyTable}
        dataSource={
          isLoading ? [] :
            (mode === 0 ? (
              listCameraByState?.devices?.map((camera) => ({
                ...camera,
                key: camera.serial,
              }))
            ) : (
              listGatewayByState?.devices?.map((gateway) => ({
                ...gateway,
                key: gateway.serial,
              }))
            ))
        }
        rowSelection={deviceState === 0 ? {
          preserveSelectedRowKeys: true,
          onChange: (keys, row) => {
            setDataDeviceSelect(row)
            if (row?.length > 0) {
              const data = row?.map(item => `<tr class="ant-table-row ant-table-row-level-0" data-row-key=${item?.serial ?? ''}>
              <td class="ant-table-cell">${item?.name ?? ''}</td>
              <td class="ant-table-cell">${item?.serial ?? ''}</td>
              <td class="ant-table-cell">Offline</td>
              <td class="ant-table-cell">${item?.note ?? ''}</td>
              </tr>`)

              setDataEditorTable(`<table>
              <thead class="ant-table-thead">
              <tr>
              <th class="ant-table-cell" style="text-align: left;">Name</th>
              <th class="ant-table-cell" style="text-align: left;">Serial</th>
              <th class="ant-table-cell" style="text-align: left;">State</th>
              <th class="ant-table-cell" style="text-align: left;">Address</th>
              </tr>
              </thead>
              <tbody class="ant-table-tbody">
              ${data?.join('') ?? ''}
              </tbody>
              </table>`)
            } else {
              setDataEditorTable('')
            }
          },
        } : undefined}
        columns={mode === 0 ? cameraColumns : gatewayColumns}
        pagination={{
          total:
            mode === 0 ? listCameraByState?.total : listGatewayByState?.total,
          current: page + 1,
          onChange: (page) => {
            setPage(page - 1);
          },
        }}
      />
      <Modal
        visible={visiblSendMail}
        title={t('Send Email')}
        onCancel={() => onCancelSendMail()}
        footer={null}
        width="70vw"
        style={{ top: 50 }}
      >
        {visiblSendMail && (
          <Spin spinning={isLoadingSendEmail}>
            <div className="send-mail-component">
              <Form
                form={formSendEmail}
                {...layout}
                name="form_edit_gateway"
                onFinish={(value) => handleOnSend(value)}
              >
                <Form.Item
                  name="emailTitle"
                  label={t('Title')}
                  rules={[
                    {
                      required: true,
                      message: t('Please input the title!'),
                    },
                    {
                      max: 80,
                      message: t('Please input up to 80 characters!'),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="emails"
                  className="edit-email"
                  label={t('Email')}
                  style={{ borer: '1px solid #434343', borderRadius: '2px' }}
                >
                  <InputTag numberTag={3} nameAdd="Add email" />
                </Form.Item>
                <Form.Item
                  label={t('Content')}
                >
                  <TinymceEditor
                    id="emailContent"
                    key="emailContent"
                    editorRef={emailContentRef}
                    value={dataEditorTable ?? ''}
                    heightEditor="400px"
                  />
                </Form.Item>
                <div className="btn-update-gateway">
                  <Button onClick={() => onCancelSendMail()}>{t('Cancel')}</Button>
                  <Form.Item shouldUpdate={true}>
                    {() => (
                      <Button
                        icon={<SaveOutlined />}
                        htmlType="submit"
                        loading={isLoad}
                        type="primary"
                        disabled={
                          !formSendEmail.isFieldsTouched(true) ||
                          formSendEmail.getFieldsError().filter(({ errors }) => errors.length)
                            .length
                        }
                      >
                        {t('Send')}
                      </Button>
                    )}
                  </Form.Item>
                </div>
              </Form>
            </div>
          </Spin>
        )}
      </Modal>
      <Modal
        visible={visiblMaintain}
        title={t('Move to maintain')}
        onCancel={() => onCancelMaintain()}
        footer={null}
        width="35vw"
        style={{ top: 50 }}
      >
        {visiblMaintain && (
          <div className="maintain-component">
            <div style={{ marginBottom: "20px" }}>
              {dataDeviceSelect?.map(deviceItem => (
                <div style={{ marginBottom: '5px' }}>
                  <Tag
                    closable
                    onClose={(e) => handleOnClose(e, deviceItem)}
                  >
                    {deviceItem?.serial ? `${deviceItem?.name} (${deviceItem?.serial})` : ''}
                  </Tag>
                </div>
              ))}
            </div>
            <div className="btn-update-gateway">
              <Button onClick={() => onCancelMaintain()}>{t('Cancel')}</Button>
              <Form.Item shouldUpdate={true}>
                {() => (
                  <Button
                    icon={<SaveOutlined />}
                    type="primary"
                    disabled={
                      !dataDeviceSelect?.length
                    }
                    onClick={() => onSubmitMaintain(dataDeviceSelect)}
                  >
                    {t('Update')}
                  </Button>
                )}
              </Form.Item>
            </div>
          </div>
        )}
      </Modal>
    </Modal>
  );
};

export default ModalListDevice;


export const convertFilterToParams = (filter) => {
  const { fromDate, toDate, ...restFilter } = filter;
  return {
    ...restFilter,
    fromTime: fromDate.startOf('day').valueOf(),
    toTime: toDate.endOf('day').valueOf()
  };
};